const Items = [
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-1',
        theme: 'Poner a Cristo Primero',
        ref: 'Mateo 6:33',
        text: {
            lbla: 'Pero buscad primero su reino y su justicia, y todas estas cosas os serán añadidas.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-2',
        theme: 'Poner a Cristo Primero',
        ref: 'Lucas 9:23',
        text: {
            lbla: 'Y decía a todos: Si alguno quiere venir en pos de mí, niéguese a sí mismo, tome su cruz cada día y sígame.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-3',
        theme: 'Separados del Mundo',
        ref: '1 Juan 2:15,16',
        text: {
            lbla: 'No améis al mundo ni las cosas que están en el mundo. Si alguno ama al mundo, el amor del Padre no está en él.  Porque todo lo que hay en el mundo, la pasión de la carne, la pasión de los ojos y la arrogancia de la vida, no proviene del Padre, sino del mundo.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-4',
        theme: 'Separados del Mundo',
        ref: 'Romanos 12:2',
        text: {
            lbla: 'Y no os adaptéis a este mundo, sino transformaos mediante la renovación de vuestra mente, para que verifiquéis cuál es la voluntad de Dios: lo que es bueno, aceptable y perfecto.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-5',
        theme: 'Ser Firme',
        ref: '1 Corintios 15:58',
        text: {
            lbla: 'Por tanto, mis amados hermanos, estad firmes, constantes, abundando siempre en la obra del Señor, sabiendo que vuestro trabajo en el Señor no es en vano.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-6',
        theme: 'Ser Firme',
        ref: 'Hebreos 12:3',
        text: {
            lbla: 'Considerad, pues, a aquel que soportó tal hostilidad de los pecadores contra sí mismo, para que no os canséis ni os desaniméis en vuestro corazón.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-7',
        theme: 'Servir a los Demás',
        ref: 'Marcos 10:45',
        text: {
            lbla: 'Porque ni aun el Hijo del Hombre vino para ser servido, sino para servir, y para dar su vida en rescate por muchos.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-8',
        theme: 'Servir a los Demás',
        ref: '2 Corintios 4:5',
        text: {
            lbla: 'Porque no nos predicamos a nosotros mismos, sino a Cristo Jesús como Señor, y a nosotros como siervos vuestros por amor de Jesús.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-9',
        theme: 'Dar Generosamente',
        ref: 'Proverbios 3:9,10',
        text: {
            lbla: 'Honra al Señor con tus bienes y con las primicias de todos tus frutos; entonces tus graneros se llenarán con abundancia y tus lagares rebosarán de mosto.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-10',
        theme: 'Dar Generosamente',
        ref: '2 Corintios 9:6,7',
        text: {
            lbla: 'Pero esto digo: Él que siembra escasamente, escasamente también segará; y el que siembra abundantemente, abundantemente también segará. Que cada uno dé como propuso en su corazón, no de mala gana ni por obligación, porque Dios ama al dador alegre.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-11',
        theme: 'Desarrollar una Visión Global',
        ref: 'Hechos 1:8',
        text: {
            lbla: 'pero recibiréis poder cuando el Espíritu Santo venga sobre vosotros; y me seréis testigos en Jerusalén, en toda Judea y Samaria, y hasta los confines de la tierra.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Ser Discipulo de Cristo',
        number: 'D-12',
        theme: 'Desarrollar una Visión Global',
        ref: 'Mateo 28:19,20',
        text: {
            lbla: 'Id, pues, y haced discípulos de todas las naciones, bautizándolos en el nombre del Padre y del Hijo y del Espíritu Santo, enseñándoles a guardar todo lo que os he mandado; y he aquí, yo estoy con vosotros todos los días, hasta el fin del mundo.'
        }
    }
];

export default Items;
